exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#questCollapseContainer{margin-bottom:15px}#questCollapseContainer .btnCollapse{text-align:left}#questCollapseContainer .btnCollapse,#questCollapseContainer .collapseContent{width:100%;background:#242527 0 0 no-repeat padding-box;border-radius:20px;opacity:1;border:none;display:flex;justify-content:space-between;padding:15px}", ""]);

// exports
